import { AccountLevelEnum, AccountStatusEnum, SnackBarVariants } from '@app/app.enum';
import store from '@app/app.store';
import withSnackBar from '@app/components/core/message.component';
import CloseAccountComponent from '@app/components/shared/close-account.component';
import * as models from '@app/models';
import Injector from '@app/services';
import { AccountService } from '@app/services/account.service';
import { SharedService } from '@app/services/shared.service';
import { Grid, Typography } from '@material-ui/core';
import Axios from 'axios';
import React from 'react';

const accountService: AccountService = Injector.get(AccountService);
const sharedService: SharedService = Injector.get(SharedService);

class AdminDetailsComponent extends React.Component<models.IAdminCustomerDetailsProps, any> {
	public isPartnerAccount: boolean;
	private isAdmin: boolean;
	constructor(props: models.IAdminCustomerDetailsProps) {
		super(props);
		this.state = {
			openAccountClosureDialog: false,
		};
		this.isAdmin = accountService.IsAdmin(store.getState().authentication.user.role);
	}

	public render() {
		this.isPartnerAccount = this.props.customerAccount.level === AccountLevelEnum.Partner;
		return (
			<>
				{/* Close Account */}
				{this.state.openAccountClosureDialog && (
					<CloseAccountComponent
						openDialog={this.state.openAccountClosureDialog}
						onCloseAccount={this.onCloseAccount}
						dialogDescription={this.props.intl.formatMessage({
							id: 'app.admin-details.user-info-form.close.account-dialog-box-description',
						})}
						closeDialog={this.closeAccountClosureDialog}
					/>
				)}
				<Grid container={true}>
					<Grid item={true} xs={12} sm={12} md={12}>
						<Grid container={true} spacing={1}>
							{!this.isPartnerAccount && (
								<Grid item={true} xs={2} sm={2} md={2} xl={2}>
									<Typography color='inherit' variant='body2'>
										<strong>
											{this.props.intl.formatMessage({
												id: 'app.account.partner-visible-account-label',
											})}
										</strong>
									</Typography>
								</Grid>
							)}
							{!this.isPartnerAccount && (
								<Grid item={true} xs={4} sm={4} md={4}>
									<Typography variant='body2'>{this.props.partnerVisibleAccountNum || '-'}</Typography>
								</Grid>
							)}
							{
								<Grid item={true} xs={2} sm={2} md={2} xl={2}>
									<Typography color='inherit' variant='body2'>
										<strong>
											{`${this.props.intl.formatMessage({
												id: 'app.profile.user-info-form.visible-account-number-label',
											})}`}
										</strong>
									</Typography>
								</Grid>
							}
							{
								<Grid item={true} xs={4} sm={4} md={4}>
									<Typography variant='body2'>{this.props.visibleAccountNumber || '-'}</Typography>
								</Grid>
							}
							<Grid item={true} xs={2} sm={2} md={2} xl={2}>
								<Typography color='inherit' variant='body2'>
									<strong>
										{this.props.intl.formatMessage({
											id: 'app.account.customer-visible-account-label',
										})}
									</strong>
								</Typography>
							</Grid>
							<Grid item={true} xs={4} sm={4} md={4}>
								<Typography variant='body2'>{this.props.customerAccount.name}</Typography>
							</Grid>
							<Grid item={true} xs={2} sm={2} md={2} xl={2}>
								<Typography color='inherit' variant='body2'>
									<strong>
										{this.props.intl.formatMessage({
											id: 'app.customer-status',
										})}
									</strong>
								</Typography>
							</Grid>
							<Grid item={true} xs={4} sm={4} md={4}>
								<Typography variant='body2'>{this.props.customerAccount.status}</Typography>
							</Grid>
							<Grid item={true} xs={2} sm={2} md={2} xl={2}>
								<Typography color='inherit' variant='body2'>
									<strong>
										{this.props.intl.formatMessage({
											id: 'app.customer.shipment-count',
										})}
									</strong>
								</Typography>
							</Grid>
							<Grid item={true} xs={4} sm={4} md={4}>
								<Typography variant='body2'>{this.props.shipmentCount}</Typography>
							</Grid>
							{/* Do not show close account link for Partner accounts */}
							{this.isAdmin &&
								!this.isPartnerAccount &&
								this.props.customerAccount.status !== AccountStatusEnum.Closed && (
									<>
										<Grid item={true} xs={2} sm={2} md={2} xl={2} />
										<Grid item={true} xs={4} sm={4} md={4}>
											<Typography variant='body2'>
												<span
													className='active-link'
													onClick={() => {
														this.openCloseAccountDialog();
													}}
												>
													{this.props.intl.formatMessage({
														id: 'app.profile.user-info-form.close.account-link',
													})}
												</span>
											</Typography>
										</Grid>
									</>
								)}
						</Grid>
					</Grid>
				</Grid>
			</>
		);
	}

	public closeAccountClosureDialog = (dialogPanel: string, isCancel: boolean) => {
		this.setState({
			openAccountClosureDialog: false,
		});
	};

	private openCloseAccountDialog = () => {
		this.setState({
			openAccountClosureDialog: true,
		});
	};

	// close account
	private onCloseAccount = async (eventData: models.ICloseAccountRequest) => {
		try {
			eventData.accountId = this.props.customerAccount.id;
			const result = await accountService.CloseAccount(eventData);
			if (result) {
				this.props.openSnackBar(
					this.props.intl.formatMessage({
						id: 'app.snackbar.close-account-successfully',
					}),
					SnackBarVariants.Success
				);
				this.props.updateAccountStatus(AccountStatusEnum.Closed);
			}
			this.setState({
				openAccountClosureDialog: false,
			});
		} catch (error) {
			this.setState({ openDialog: false });
			if (!Axios.isCancel(error)) {
				this.props.openSnackBar(sharedService.parseError(error.data), SnackBarVariants.Error);
			}
			throw error;
		}
	};
}
export default withSnackBar(AdminDetailsComponent);



// WEBPACK FOOTER //
// ./src/components/admin/customer/admin-details.component.tsx